// extracted by mini-css-extract-plugin
export var icon = "_4g-3";
export var subtitle = "_4g-2";
export var title = "_4g-1";
export var value = "_4g-0";